import { useState, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

// ─── Your events data ───────────────────────────────────────────────
const events = [
  {
    id: 1,
    title: 'Sham mastani(Senior citizen Business opportunity event)',
    date: 'March 2025',
    location: 'New Delhi',
    photos: [
      '/images/events/img7.webp',
      '/images/events/img8.webp',
      '/images/events/img9.webp',
      '/images/events/img5.webp',
      '/images/events/img6.webp',
      '/images/events/img10.webp',
      '/images/events/img11.webp',
      '/images/events/img12.webp',
      '/images/events/img13.webp',
      '/images/events/img14.webp',
      '/images/events/img15.webp',
      '/images/events/img16.webp',
      '/images/events/img17.webp',
      '/images/events/img18.webp',
      '/images/events/img19.webp',
    ],
  },
  {
    id: 2,
    title: 'Sham mastani rewind(Senior citizen Business opportunity event)',
    date: 'April 2025',
    location: 'New Delhi',
    photos: [
      '/images/events/img21.webp',
      '/images/events/img22.webp',
      '/images/events/img23.webp',
      '/images/events/img24.webp',
      '/images/events/img25.webp',
      '/images/events/img26.webp',
      '/images/events/img20.webp',
      '/images/events/img27.webp',
      '/images/events/img28.webp',
      '/images/events/img29.webp',
    ],
  },
  // {
  //   id: 3,
  //   title: 'Wealth Management Seminar',
  //   date: 'November 2024',
  //   location: 'Gurgaon',
  //   photos: [
  //     '/images/events/img10.webp',
  //     '/images/events/img11.webp',
  //     '/images/events/img12.webp',
  //     '/images/events/img13.webp',
  //   ],
  // },
  // {
  //   id: 4,
  //   title: 'Child Education Planning Meet',
  //   date: 'September 2024',
  //   location: 'New Delhi',
  //   photos: [
  //     '/images/events/img14.webp',
  //     '/images/events/img15.webp',
  //   ],
  // },
];

// ─── Single Event Card with inline slider ───────────────────────────
function EventSliderCard({ event, darkMode }) {
  const [current, setCurrent] = useState(0);
  const touchStartX = useRef(null);
  const total = event.photos.length;

  const prev = () => setCurrent((i) => (i - 1 + total) % total);
  const next = () => setCurrent((i) => (i + 1) % total);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(dx) > 40) dx < 0 ? next() : prev();
    touchStartX.current = null;
  };

  return (
    <div
      className={`rounded-2xl overflow-hidden border transition-all duration-200 ${
        darkMode
          ? 'bg-[#0D1525] border-[#C9A84C]/10'
          : 'bg-white border-gray-100'
      }`}
    >
      {/* Card header */}
      <div className="flex items-center justify-between px-4 pt-4 pb-3">
        <div>
          <h3
            className={`text-sm font-semibold ${
              darkMode ? 'text-white' : 'text-gray-900'
            }`}
          >
            {event.title}
          </h3>
          <p
            className={`text-xs mt-0.5 ${
              darkMode ? 'text-gray-400' : 'text-gray-500'
            }`}
          >
            {event.date} · {event.location}
          </p>
        </div>
        <span
          className={`text-xs tabular-nums ${
            darkMode ? 'text-gray-500' : 'text-gray-400'
          }`}
        >
          {current + 1} / {total}
        </span>
      </div>

      {/* Slider */}
      <div
        className="relative overflow-hidden aspect-[3/4] bg-gray-100 cursor-grab active:cursor-grabbing"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        {/* Track */}
        <div
          className="flex h-full transition-transform duration-300 ease-in-out"
          style={{ transform: `translateX(-${current * 100}%)` }}
        >
          {event.photos.map((src, idx) => (
            <div key={idx} className="flex-shrink-0 w-full h-full">
              <img
                src={src}
                alt={`${event.title} ${idx + 1}`}
                className="w-full h-full object-cover"
                draggable={false}
              />
            </div>
          ))}
        </div>

        {/* Prev button */}
        {total > 1 && (
          <button
            onClick={prev}
            className="absolute left-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/40 hover:bg-black/60 flex items-center justify-center text-white transition-colors"
          >
            <ChevronLeft size={18} />
          </button>
        )}

        {/* Next button */}
        {total > 1 && (
          <button
            onClick={next}
            className="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/40 hover:bg-black/60 flex items-center justify-center text-white transition-colors"
          >
            <ChevronRight size={18} />
          </button>
        )}
      </div>

      {/* Dot indicators */}
      {total > 1 && (
        <div className="flex items-center justify-center gap-1.5 py-3">
          {event.photos.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrent(idx)}
              className={`rounded-full transition-all duration-200 ${
                idx === current
                  ? 'w-4 h-1.5 bg-[#C9A84C]'
                  : `w-1.5 h-1.5 ${darkMode ? 'bg-gray-600' : 'bg-gray-300'}`
              }`}
            />
          ))}
        </div>
      )}

      {/* Thumbnail strip */}
      {total > 1 && (
        <div
          className={`flex gap-2 px-4 pb-4 overflow-x-auto scrollbar-hide`}
        >
          {event.photos.map((src, idx) => (
            <button
              key={idx}
              onClick={() => setCurrent(idx)}
              className={`flex-shrink-0 w-12 h-10 rounded-lg overflow-hidden border-2 transition-all duration-150 ${
                idx === current
                  ? 'border-[#C9A84C] scale-105'
                  : darkMode
                  ? 'border-transparent opacity-50 hover:opacity-80'
                  : 'border-transparent opacity-60 hover:opacity-100'
              }`}
            >
              <img
                src={src}
                alt={`thumb ${idx + 1}`}
                className="w-full h-full object-cover"
                draggable={false}
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Main Events Section ─────────────────────────────────────────────
export default function Events({ darkMode }) {
  return (
    <section id="events" className="py-24">
      <div className="container mx-auto px-4 lg:px-16">
        {/* Section heading */}
        <div className="text-center mb-12">
          <p
            className={`text-xs font-semibold tracking-widest uppercase mb-2 ${
              darkMode ? 'text-[#C9A84C]' : 'text-[#C9A84C]'
            }`}
          >
            Portfolio
          </p>
          <h2
            className={`text-3xl md:text-4xl font-bold tracking-tight ${
              darkMode ? 'text-white' : 'text-gray-900'
            }`}
          >
            Our Events Gallery
          </h2>
        </div>

        {/* Events grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {events.map((event) => (
            <EventSliderCard key={event.id} event={event} darkMode={darkMode} />
          ))}
        </div>
      </div>
    </section>
  );
}